import React, { PropTypes } from 'react';
import DataService from '../../lib/DataService';
import SharedTools from '../../lib/SharedTools';
import { hashHistory } from 'react-router';

export default class ObservationStudentsListPage extends React.Component {
  static propTypes = {
    // name: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    // set state
    this.state = {
      observationId: props.params.observationId ? props.params.observationId : 0,
      classId: props.params.classId ? props.params.classId : 1,
      semester: props.location.query.semester ? props.location.query.semester : SharedTools.getCurrentSemester(),
      students: []
    };
    // bind this
  }

  componentDidMount() {
    if (this.state.observationId && this.state.classId) {
      this.getObservationDetail();
      this.getStudentsList()
    }
  }

  getStudentsList() {
    let data = {
      class_id: this.state.classId,
      semester: this.state.semester,
      info: 'evaluation',
      observation_id: this.state.observationId
    }
    DataService.getStudentsList(data).then((res) => {
      this.setState({
        students: res
      })
    }).catch((error) => {
      console.log(error);
    });
  }

  getObservationDetail() {
    DataService.getObservationDetail(this.state.observationId).then((res) => {
      this.setState({
        observation: res
      })
    }).catch((error) => {
      console.log(error);
    });
  }

  formatDate = (record_date) => {
    var date = new Date(record_date);
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    m = m < 10 ? '0' + m : m;
    var d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    return y + '-' + m + '-' + d;
  }

  getAlbumCover = (url) => {
    if (url.indexOf('?imgeView2') >= 0 || url.indexOf('?imageMogr2') >= 0) {
      return url;
    }
    return url + '?imageView2/1/w/300';
  }

  getObservationRecord = (student) => {    
    hashHistory.push(`development/observation-record/classes/${this.state.classId}/observations/${this.state.observationId}/students/${student.id}?finalEvaluation=${student.is_complete}&semester=${this.state.semester}`);
  }

  render() {
    let { observation } = this.state;
    return (
      <div className="observation-students-list-page">
        <div className="container">
          <div className="title">{observation ? observation.segments_info[0].text : ''}</div>
          <div className="time">{observation ? this.formatDate(observation.record_date) : ''}</div>
          <div>
            <img src={observation ? this.getAlbumCover(observation.segments_info[0].image_url) : ''} alt="" className="img" />
          </div>
          <div className="students-list">
            {this.state.students.map(student => <div className="student-item" key={student.id} onClick={() => this.getObservationRecord(student)}>
              <div className="student-name">{student.full_name}</div>
              {student.is_complete ? <span className="evaluate-label">修改评价</span> : <a>点击评价</a>}
            </div>)}
          </div>
        </div>
      </div>
    )
  }
} 


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/development/ObservationStudentsListPage.jsx